// @ts-nocheck
import React from "react";
import axios from "axios";
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import { Form, FormWithoutStyle } from "../../Componentes/useForm";
import { useUsuarios } from "../State/UsuarioContext";
import FormInput from "../../Componentes/FormInput";
import Grid from "@mui/material/Grid";
import Joi from "joi";
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import Typography from "@mui/material/Typography";
import { DialogContent as ModalContent } from '@mui/material';
import SinapTheme from "../../styles/SinapTheme";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useBody } from "../../Body/state/BodyContext";
import { SaveButton } from "../../Componentes/inputs/SaveButton";
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField } from '@mui/x-date-pickers/DateField';
import { EXTENSION_MAIL_INSTITUCIONAL, RUTA_API_USUARIOS, URL_API_SIA } from "../../Contantes/Constantes";
import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import HomeIcon from '@mui/icons-material/Home';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import CircularIndeterminate from '../../Componentes/CircularIndeterminate';
import LockIcon from '@mui/icons-material/Lock';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import { useHistory } from "react-router-dom";
import dayjs from 'dayjs';
import { useFormulario } from "../State/FormularioState/FormularioContext";
import Dialog from '@mui/material/Dialog';
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import { useTheme } from '@mui/material/styles';

const useStyles = makeStyles(theme => ({
    typografy: {
        marginTop: '2%',
        width: "100%",
        color: SinapTheme.palette.primary.main,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-start',
        '& > *': {
            margin: "8px",
        },
        flexGrow: 1,
        maxWidth: 752,
    },
    label: {
        paddingLeft: "16px",
        paddingTop: "14.4px"
    },
    header_forms: {
        textDecoration: 'underline'
    }
}))

function getStyles(nombre, personName, theme) {
    return {
        fontWeight: 2
    };
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export const ModalDetallesUsuario = ({ actualizarTabla, actualizarInfoPrev, open, onClose, type, tab, prev, mostrarContrasena, ...props }) => {
    const theme = useTheme();
    const searchParams = new URLSearchParams(document.location.search)
    const { provincias, paises, loading, setLoading, getAltasPendientes, fetchUsuariosBuscado } = useUsuarios();
    const { setSexos, setFiliaciones, setSedes, setFechaNacimiento, setTiposDocumentoDeIdentificacion,
        sexos, filiaciones, sedes, fechaNacimiento, tiposDocumentoDeIdentificacion, resetearForm } = useFormulario();
    const { setMessage, setSuccess } = useBody();
    const [errores, setErrores] = React.useState({
        apellido: false,
        nombre: false,
        uid: false,
        frbaEmail: false,
        SexoId: false,
        SedeId: false,
        Direccion: false,
        FiliacionId: false,
        fechaNacimiento: false,
        codigoPostal: false,
        telefonoDomiciliario: false,
        telefonoCelular: false,
        personalEmail: false,
        legajoAlumno: false,
        legajoPersonaUTN: false,
        nacionalidad: false,
        DocumentoDeIdentificacion: false,
        password: false,
        repeat_password: false,
        provincia: false,
        ciudad: false,
        calle: false,
        altura: false
    });
    const [value, setValue] = React.useState({
        nombre: '',
        apellido: '',
        uid: '',
        frbaEmail: EXTENSION_MAIL_INSTITUCIONAL,
        fechaNacimiento: null,
        SexoId: 0,
        SedeId: 0,
        estadoCivil: null,
        password: '',
        repeat_password: '',
        Direccion: {
            calle: '',
            altura: '',
            ciudad: '',
            provincia: 0,
            codigoPostal: '',
        },
        FiliacionId: 0,
        telefonoDomiciliario: '',
        telefonoCelular: '',
        personalEmail: '',
        legajoAlumno: '',
        legajoPersonaUTN: '',
        nacionalidad: 0,
        DocumentoDeIdentificacion: {
            numero: '',
            TipoDocumentoDeIdentificacionId: 0
        }
    });
    const [filiacionesSeleccionadas, setFiliacionesSeleccionadas] = React.useState([]);
    const matches = useMediaQuery('(max-width:600px)');

    const classes = useStyles();
    const axiosInstance = setupInterceptorsTo(axios.create());

    const handleChangeFiliacionOption = (key, nombre) => {
        if (value.filiaciones.find(filiacion => filiacion.id === key)) {
            setFiliacionesSeleccionadas(filiacionesSeleccionadas.filter(filiacion => filiacion !== nombre))
            setValue(prev => ({
                ...prev,
                filiaciones: prev.filiaciones.filter(filiacion => filiacion.id !== key)
            }))
        }
        else {
            setFiliacionesSeleccionadas(filiacionesSeleccionadas.concat(nombre))
            setValue(prev => ({
                ...prev,
                filiaciones: [...prev.filiaciones, ({ id: key, nombre: nombre })]
            }))
        }
    }



    React.useEffect(() => {
        window.scrollTo(0, 0);
        axios({
            method: 'GET',
            url: `${RUTA_API_USUARIOS}/formulario/ldap/info`,
        })
            .then((response) => {
                mapearInformacion(response.data);
            })
            .catch(error => {
                setMessage("Ocurrio un error al querer obtener información del formulario (Codigo de error: 00036)");
            })

    }, [])

    React.useEffect(() => {
        if (prev !== undefined)
            if (prev.uid !== '') {
                let fecha = dayjs(prev.fechaNacimiento).$d.toString()

                delete prev.password
                delete prev.repeat_password
                delete prev.pwd
                setValue(({
                    ...prev,
                    fechaNacimiento: fecha,
                    DocumentoDeIdentificacion: {
                        id: prev.DocumentoDeIdentificacion.id,
                        numero: prev.DocumentoDeIdentificacion.numero,
                        TipoDocumentoDeIdentificacionId: prev.DocumentoDeIdentificacion.TipoDocumentoDeIdentificacion.id
                    },
                    estadoCivil: prev.estadoCivil,
                    SexoId: prev.Sexo.id,
                    Direccion: {
                        id: prev.Direccion.id,
                        calle: prev.Direccion.calle,
                        altura: prev.Direccion.altura,
                        ciudad: prev.Direccion.ciudad,
                        provincia: mapProvincia(prev.Direccion.provincia),
                        codigoPostal: prev.Direccion.codigoPostal,
                    },
                    filiaciones: prev.Filiacions ? prev.Filiacions : [],
                    SedeId: prev.Sede.id,
                    legajoPersonaUTN: prev.legajoPersona
                }))
                setFiliacionesSeleccionadas(prev.Filiacions ? prev.Filiacions.map(filiacion => filiacion.nombre) : [])
                setFechaNacimiento(dayjs(prev.fechaNacimiento))
                delete value.legajoPersona
            }
    }, [prev])

    /**
     * La consulta de la API debería devolver 4 keys: filiaciones, sedes, generos y tiposDocumentoDeIdentificacion
     */
    const mapearInformacion = (response) => {
        if (response.filiaciones.length !== 0)
            setFiliaciones(response.filiaciones)
        else setMessage("Hubo un error al querer cargar las filiaciones")
        if (response.sedes.length !== 0)
            setSedes(response.sedes)
        else setMessage("Hubo un error al querer cargar las sedes")
        if (response.sexos.length !== 0)
            setSexos(response.sexos)
        else setMessage("Hubo un error al querer cargar los generos")
    }
    const mapProvincia = (provincia) => {
        if (provincia === "Capital Federal") return "Ciudad Autónoma de Buenos Aires";
        if (provincia === "Distrito Federal") return "Ciudad Autónoma de Buenos Aires";
        else return provincia
    }
    const handleSubmit = async (e) => {
        // e.preventDefault();
        resetearErrores();
        let error = validateForm();
        if (error) {
            console.error(error)
            await scrollToTop();
            mensajeAlertaFalloFormulario(error);
            setErrores(prevState => ({
                ...prevState,
                [error]: true
            }))
            setLoading(false);
            return;
        }
        await scrollToTop();
        await axiosInstance({
            method: 'PUT',
            url: RUTA_API_USUARIOS + '/ldap/users/' + prev.uid,
            data: value
        }).then(response => {
            setSuccess("El usuario se modificó con exito")
            let buscado = searchParams.get('search')

            actualizarInfoPrev()
            buscado ? fetchUsuariosBuscado(buscado) : actualizarTabla()
            onClose()
            setLoading(false)
        }).catch(error => {
            setMessage("Hubo un error al querer actualizar el usuario (Código de error: 00055)")
            onClose()
            setLoading(false)
        })
    }

    function validateForm() {
        let validation = validationSchema.validate(value);
        if (validation.error)
            if (validation.error.details[0].path[0] === 'Direccion')
                return validation.error.details[0].path[1];
            else {
                setMessage("Hubo un error al querer validar el formulario, error en el campo: " + validation.error.details[0].path[0])
                return validation.error.details[0].path[0]
            }

    }

    const validaciones = {
        id: Joi.number().integer().allow(null),
        nombre: Joi.string().min(3).max(150).required(),
        apellido: Joi.string().min(3).max(150).required(),
        uid: Joi.string().min(3).max(20).required(),
        estadoCivil: Joi.string().min(3).max(20).required(),
        frbaEmail: Joi.string().min(10).max(120).email({ minDomainSegments: 2, tlds: { allow: ['com', 'net', 'ar'] } }).required(),
        fechaNacimiento: Joi.date(),
        password: Joi.string(),
        telefonoDomiciliario: Joi.alternatives().try(
            Joi.string().allow(''),
            Joi.array().items(Joi.string())
        ).allow(null),
        telefonoCelular: Joi.alternatives().try(
            Joi.string().allow(''),
            Joi.array().items(Joi.string())
        ).allow(null),
        repeat_password: Joi.string(),
        personalEmail: Joi.string().min(10).max(120).email({ minDomainSegments: 2, tlds: { allow: ['com', 'net', 'ar', 'etu', 'utc', 'fr'] } }).allow(null).allow(""),
        Filiacions: Joi.array(),
        Direccion: Joi.object({
            id: Joi.number().integer().allow(null),
            provincia: Joi.string().allow(null).allow(""),
            ciudad: Joi.string().allow(null).allow(""),
            calle: Joi.alternatives().try(
                Joi.string().allow(null).allow(""),
                Joi.array().items(Joi.string())
            ),
            altura: Joi.number().integer().min(1).allow(null).allow(""),
            codigoPostal: Joi.alternatives().try(
                Joi.number().integer().min(1).allow(null).allow(""),
                Joi.array().items(Joi.string())
            ),
        }),
        DocumentoDeIdentificacion: Joi.object({
            id: Joi.number().integer().allow(null),
            numero: Joi.alternatives().try(
                Joi.number().integer().min(1),
                Joi.string(),
            ),
            TipoDocumentoDeIdentificacionId: Joi.number().integer().min(1).allow(null).allow(""),
        }),
        SexoId: Joi.number()
            .integer()
            .min(1)
            .max(3).allow(null).allow(""),
        nacionalidad: Joi.string(),
        FiliacionId: Joi.number().integer().min(1).max(10),
        SedeId: Joi.number().integer().min(1).max(10).allow(null),
        legajoAlumno: Joi.string().min(1).max(8).allow('').allow(null).allow("-"),
        legajoPersonaUTN: Joi.string().min(1).max(8).allow('').allow(null).allow("-"),
        legajoPersona: Joi.string().min(1).max(6).allow('').allow(null).allow("-"),
        activoSINAP: Joi.string().min(1).max(6).allow('').allow(null),
        filiaciones: Joi.array().allow(null),
        Sexo: Joi.object({
            id: Joi.number().integer().allow(null),
            nombre: Joi.string().allow('')
        }),
        Filiacion: Joi.object({
            id: Joi.number().integer().allow(null),
            nombre: Joi.string().allow('')
        }),
        Sede: Joi.object({
            id: Joi.number().integer().allow(null),
            nombre: Joi.string().allow('')
        })
    }

    if (!mostrarContrasena) {
        delete validaciones.password
        delete validaciones.repeat_password
        delete validaciones.pwd
    }

    const validationSchema = Joi.object(validaciones);

    const mensajeAlertaFalloFormulario = (fallo) => {
        if (fallo === "apellido") setMessage("El apellido debe tener entre 3 y 150 caracteres");
        if (fallo === "nombre") setMessage("El nombre debe tener entre 3 y 150 caracteres");
        if (fallo === "uid") setMessage("El uid deben tener entre 3 y 20 caracteres");
        if (fallo === "frbaEmail") setMessage("El formato del Email Institucional es invalido");
        if (fallo === "fechaNacimiento") setMessage("El formato de la fecha de nacimiento es erroneo");
        if (fallo === "SexoId") setMessage("Debe seleccionar un genero");
        if (fallo === "legajoAlumno") setMessage("El legajo de alumno ingresado es erroneo");
        if (fallo === "legajoPersonaUTN") setMessage("El legajo de personal UTN ingresado es erroneo");
        if (fallo === "nacionalidad") setMessage("Seleccione el país correspondiente a su nacionalidad");
        if (fallo === "personalEmail") setMessage("El mail personal es invalido");
        if (fallo === "Direccion") setMessage("Debe ingresar una dirección valida");
        if (fallo === "DocumentoDeIdentificacion") setMessage("Debe ingresar sus datos de documentación para identificación");
        if (fallo === "FiliacionId") setMessage("Seleccione una filiación");
        if (fallo === "SedeId") setMessage("Seleccione una sede");
        if (fallo === "password") setMessage("Ingrese su contraseña");
        if (fallo === "repeat_password") setMessage("Repita su contraseña");
        if (fallo === "ciudad") setMessage("Ingrese la ciudad donde vive");
        if (fallo === "provincia") setMessage("Seleccione la provincia donde vive");
        if (fallo === "calle") setMessage("Ingrese una calle valida");
        if (fallo === "codigoPostal") setMessage("Ingrese un codigo postal valido");
        if (fallo === "altura") setMessage("Ingrese una altura valida");
    }

    const scrollToTop = () => {
        document.getElementById('slide-top').scrollIntoView({ behavior: 'smooth', block: 'start' })
        setLoading(true);
    }

    const onChange = (e) => {
        setValue({
            ...value,
            [e.target.name]: e.target.value
        });
    }

    const onChangeForOnlyDigits = (e) => {
        setValue({
            ...value,
            [e.target.name]: e.target.value.replace(/\D/g, '')
        });
    }

    const handleChangeNombreUsuario = (e) => {
        e.persist()
        setValue(prevState => ({
            ...prevState,
            [e.target.name]: e.target.value,
            frbaEmail: e.target.value + EXTENSION_MAIL_INSTITUCIONAL,
        }))
    }

    const onChangeForOnlyStrings = (e) => {
        setValue({
            ...value,
            [e.target.name]: e.target.value.replace(/[^a-z\s]/gi, '')
        });
    }

    const resetearErrores = () => {
        setErrores({
            apellido: false,
            nombre: false,
            uid: false,
            frbaEmail: false,
            SexoId: false,
            SedeId: false,
            Direccion: false,
            FiliacionId: false,
            fechaNacimiento: false,
            codigoPostal: false,
            telefonoDomiciliario: false,
            telefonoCelular: false,
            personalEmail: false,
            legajoAlumno: false,
            legajoPersonaUTN: false,
            nacionalidad: false,
            DocumentoDeIdentificacion: false,
            password: false,
            repeat_password: false,
            provincia: false,
            ciudad: false,
            calle: false,
            altura: false
        })
    }

    const handleChange = (event) => {
        setValue(prevState => ({
            ...prevState,
            [event.target.name]: event.target.value
        }))
    }

    const handleChangeFechaNacimiento = (event) => {
        var fecha = event.$d.toString()

        setValue(prevState => ({
            ...prevState,
            fechaNacimiento: fecha,
        }))
        setFechaNacimiento(event)
    }

    const handleChangeDireccionCalle = (event) => {
        event.persist()
        setValue(prevState => ({
            ...prevState,
            Direccion: {
                ...prevState.Direccion,
                calle: event.target.value,
            },
        }))
    }

    const handleChangeDireccionAltura = (event) => {
        event.persist()
        setValue(prevState => ({
            ...prevState,
            Direccion: {
                ...prevState.Direccion,
                altura: event.target.value.replace(/\D/g, ''),
            },
        }))
    }

    const handleChangeDireccionCiudad = (event) => {
        event.persist()
        setValue(prevState => ({
            ...prevState,
            Direccion: {
                ...prevState.Direccion,
                ciudad: event.target.value,
            },
        }))
    }

    const handleChangeDireccionProvincia = (event) => {
        setValue(prevState => ({
            ...prevState,
            Direccion: {
                ...prevState.Direccion,
                provincia: event.target.value,
            },
        }))
    }

    const handleChangeDireccionCodigoPostal = (event) => {
        event.persist()
        setValue(prevState => ({
            ...prevState,
            Direccion: {
                ...prevState.Direccion,
                codigoPostal: event.target.value.replace(/\D/g, ''),
            },
        }))
    }

    return (
        <Box>
            {loading ? <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
            > <CircularIndeterminate /> </Grid>
                :
                <>
                    <Dialog
                        open={open}
                        onClose={onClose}
                        scroll={'paper'}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={{
                            padding: 3,
                            height: { xs: "500px", md: "auto" }
                        }}>
                            <div id="slide-top" />
                            <FormWithoutStyle onSubmit={handleSubmit} >

                                <div>
                                    <br />
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'center'
                                            }}> <Avatar sx={{ bgcolor: SinapTheme.palette.secondary.light }}><PersonIcon /> </Avatar></div>
                                            <br />
                                            <Typography align={'center'} variant={matches ? "h5" : "h4"}>
                                                Datos personales
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <br />
                                    <Grid container
                                        spacing={2}
                                        justifyContent="center"
                                    >
                                        <Grid item xs={11}>
                                            <FormInput
                                                fullWidth
                                                name="apellido"
                                                label="Apellido/s"
                                                error={errores.apellido}
                                                value={value.apellido}
                                                onChange={(e) => { onChangeForOnlyStrings(e) }}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                            />
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormInput
                                                fullWidth
                                                name="nombre"
                                                label="Nombre/s"
                                                error={errores.nombre}
                                                value={value.nombre}
                                                onChange={(e) => { onChangeForOnlyStrings(e) }}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                            />
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormInput
                                                fullWidth
                                                name="uid"
                                                label="Nombre de Usuario"
                                                error={errores.uid}
                                                value={value.uid}
                                                disabled
                                                onChange={handleChangeNombreUsuario}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                            />
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormInput
                                                fullWidth
                                                name="numero"
                                                label="Numero de documento"
                                                error={errores.DocumentoDeIdentificacion.numero}
                                                value={value.DocumentoDeIdentificacion.numero}
                                                disabled
                                                onChange={(e) => { onChange(e) }}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                            />
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormInput
                                                disabled
                                                fullWidth
                                                name="frbaEmail"
                                                label="Email Institucional"
                                                error={errores.frbaEmail}
                                                value={value.frbaEmail}
                                                onChange={(e) => { onChange(e) }}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                            />
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormInput
                                                fullWidth
                                                name="personalEmail"
                                                label="Email personal"
                                                error={errores.personalEmail}
                                                value={value.personalEmail}
                                                onChange={(e) => { onChange(e) }}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                            />
                                        </Grid>
                                        <Grid item xs={11}>
                                            <LocalizationProvider fullWidth dateAdapter={AdapterDayjs}>
                                                <DateField error={errores.fechaNacimiento} value={fechaNacimiento} fullWidth onChange={handleChangeFechaNacimiento} format="DD/MM/YYYY" label="Fecha de nacimiento" />
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormControl fullWidth>
                                                <InputLabel id="select-sexo-label">Género:</InputLabel>
                                                <Select
                                                    name="SexoId"
                                                    color="primary"
                                                    error={errores.SexoId}
                                                    labelId="select-area-label"
                                                    label="Sexo"
                                                    id="select-sexo"
                                                    value={value.SexoId}

                                                    onChange={handleChange}
                                                >
                                                    <MenuItem value={0}>
                                                        <em>Seleccione su genero</em>
                                                    </MenuItem>
                                                    {sexos.map(sexo => <MenuItem key={sexo.id} value={sexo.id}>{sexo.nombre}</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormInput
                                                fullWidth
                                                name="telefonoCelular"
                                                label="Telefono celular"
                                                error={errores.telefonoCelular}
                                                value={value.telefonoCelular}
                                                onChange={(e) => { onChangeForOnlyDigits(e) }}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                            />
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormInput
                                                fullWidth
                                                name="telefonoDomiciliario"
                                                label="Telefono de su domicilio"
                                                error={errores.telefonoDomiciliario}
                                                value={value.telefonoDomiciliario}
                                                onChange={(e) => { onChangeForOnlyDigits(e) }}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                            />
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormControl fullWidth >
                                                <InputLabel id="select-nacionalidad-label">Nacionalidad:</InputLabel>
                                                <Select
                                                    name="nacionalidad"
                                                    color="primary"
                                                    error={errores.nacionalidad}
                                                    labelId="select-nacionalidad-label"
                                                    label="Provincia"
                                                    id="select-nacionalidad"
                                                    value={value.nacionalidad}

                                                    onChange={handleChange}
                                                >
                                                    <MenuItem value={0}>
                                                        <em>Seleccione su nacionalidad</em>
                                                    </MenuItem>
                                                    {paises.map(pais => <MenuItem key={pais} value={pais}>{pais}</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                    <br />
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'center'
                                            }}> <Avatar sx={{ bgcolor: SinapTheme.palette.secondary.light }}><HomeIcon /> </Avatar></div>
                                            <br />
                                            <Typography align={'center'} variant={matches ? "h5" : "h4"}>
                                                Datos de domicilio
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <br />
                                    <Grid container
                                        spacing={2}
                                        justifyContent="center">
                                        <Grid item xs={11}>
                                            <FormControl fullWidth>
                                                <InputLabel id="select-sexo-label">Provincia:</InputLabel>
                                                <Select
                                                    name="provincia"
                                                    color="primary"
                                                    error={errores.provincia}
                                                    labelId="select-area-label"
                                                    label="Provincia"
                                                    id="select-provincia"
                                                    value={value.Direccion.provincia}
                                                    fullwidth
                                                    onChange={handleChangeDireccionProvincia}
                                                >
                                                    <MenuItem value={0}>
                                                        <em>Seleccione una provincia</em>
                                                    </MenuItem>
                                                    {provincias.map(provincia => <MenuItem key={provincia.nombre} value={provincia.nombre}>{provincia.nombre}</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormInput
                                                fullWidth
                                                name="ciudad"
                                                label="Ciudad"
                                                error={errores.ciudad}
                                                value={value.Direccion.ciudad}
                                                onChange={handleChangeDireccionCiudad}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                            />
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormInput
                                                fullWidth
                                                name="calle"
                                                label="Calle"
                                                error={errores.calle}
                                                value={value.Direccion.calle}
                                                onChange={handleChangeDireccionCalle}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                            />
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormInput
                                                fullWidth
                                                name="altura"
                                                label="Altura"
                                                error={errores.altura}
                                                value={value.Direccion.altura}
                                                onChange={handleChangeDireccionAltura}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                            />
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormInput
                                                fullWidth
                                                name="codigoPostal"
                                                label="Codigo postal"
                                                error={errores.Direccion}
                                                value={value.Direccion.codigoPostal}
                                                onChange={handleChangeDireccionCodigoPostal}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}

                                            />
                                        </Grid>
                                    </Grid>
                                    <br />
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'center'
                                            }}> <Avatar sx={{ bgcolor: SinapTheme.palette.secondary.light }}><CorporateFareIcon /> </Avatar></div>
                                            <br />
                                            <Typography align={'center'} variant={matches ? "h5" : "h4"}>
                                                Datos laborales
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <br />
                                    <Grid container
                                        spacing={2}
                                        justifyContent="center">
                                        <Grid item xs={11}>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-multiple-chip-label">Filiacion</InputLabel>
                                                <Select
                                                    labelId="demo-multiple-chip-label"
                                                    id="demo-multiple-chip"
                                                    multiple
                                                    fullWidth
                                                    value={filiacionesSeleccionadas}
                                                    input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                                                    renderValue={(selected) => (
                                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                            {selected.map((value) => (
                                                                <Chip key={value} label={value} />
                                                            ))}
                                                        </Box>
                                                    )}
                                                    MenuProps={MenuProps}
                                                >
                                                    {filiaciones.map((filiacion) => (
                                                        <MenuItem
                                                            key={filiacion.id}
                                                            value={filiacion.nombre}
                                                            onClick={(e) => handleChangeFiliacionOption(filiacion.id, filiacion.nombre)}
                                                            style={getStyles(filiacion.nombre, value.filiaciones, theme)}
                                                        >
                                                            {filiacion.nombre}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormControl fullWidth>
                                                <InputLabel id="select-sexo-label">Sede:</InputLabel>
                                                <Select
                                                    name="SedeId"
                                                    color="primary"
                                                    error={errores.SedeId}
                                                    labelId="select-area-label"
                                                    label="Sedes"
                                                    id="select-sede"
                                                    value={value.SedeId}
                                                    fullwidth
                                                    onChange={handleChange}
                                                >
                                                    <MenuItem value={0}>
                                                        <em>Seleccione su sede</em>
                                                    </MenuItem>
                                                    {sedes.map(sede => <MenuItem key={sede.id} value={sede.id}>{sede.nombre}</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={11}>
                                            <FormInput
                                                fullWidth
                                                name="legajoAlumno"
                                                label="Legajo Alumno"
                                                error={errores.legajoAlumno}
                                                value={value.legajoAlumno}
                                                onChange={(e) => {
                                                    onChange(e)
                                                }}
                                                onKeyPress={(e) => {
                                                    e.key === 'Enter' && e.preventDefault()
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={11}>
                                            <FormInput
                                                fullWidth
                                                name="legajoPersonaUTN"
                                                label="Legajo Persona"
                                                error={errores.legajoPersonaUTN}
                                                value={value.legajoPersonaUTN}
                                                onChange={(e) => { onChange(e) }}
                                                onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <br />
                                    {mostrarContrasena ? <> <Grid container>
                                        <Grid item xs={12}>
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'center'
                                            }}><Avatar sx={{ bgcolor: SinapTheme.palette.secondary.light }}><LockIcon /> </Avatar>
                                            </div>
                                            <br />
                                            <Typography align={'center'} variant={matches ? "h5" : "h4"}>
                                                Contraseña
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                        <br />
                                        <Grid container
                                            spacing={2}
                                            justifyContent="center">
                                            <Grid item xs={11}>
                                                <FormInput
                                                    fullWidth
                                                    name="password"
                                                    label="Ingrese su contraseña"
                                                    error={errores.password}
                                                    value={value.password}
                                                    type="password"
                                                    onChange={(e) => { onChange(e) }}
                                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                                />
                                            </Grid>
                                            <Grid item xs={11}>
                                                <FormInput
                                                    fullWidth
                                                    name="repeat_password"
                                                    label="Confirme su contraseña"
                                                    error={errores.repeat_password}
                                                    value={value.repeat_password}
                                                    type="password"
                                                    onChange={(e) => { onChange(e) }}
                                                    onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </>
                                        : null}
                                </div>
                                <Divider />
                                <Grid
                                    py={2}
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <SaveButton label={"Modificar Datos"} onClick={handleSubmit} type="button" />
                                </Grid>
                            </FormWithoutStyle>
                        </Box>
                    </Dialog>
                </>
            }
        </Box>
    )
}